import React from "react";
import ButtonsSection from "components/ui/buttons/ButtonsSection";

export default function Story() {
  const [selectedPeriodView, setSelectedPeriodView] = React.useState<
    "RECENT" | "LAST_30_DAYS"
  >("RECENT");
  const [isAnimating, setIsAnimating] = React.useState(false);

  const onClickTryItNow = () => {
    setIsAnimating(true);
    // Reset animation after 12 seconds
    setTimeout(() => {
      setIsAnimating(false);
    }, 12000);
  };
  return (
    <div className="page-container trends-page-container">
      <div
        style={{
          maxWidth: "600px",
          margin: "40px auto",
          padding: "32px 24px",
          backgroundColor: "#f8fafc",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
        }}
      >
        <h1
          style={{
            fontSize: "28px",
            fontWeight: 600,
            color: "#1e293b",
            marginBottom: "24px",
            textAlign: "center",
          }}
        >
          4–4–4 Breathing
        </h1>

        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
            color: "#475569",
            marginBottom: "32px",
            textAlign: "center",
          }}
        >
          4–4–4 breathing is a simple way to slow down for a moment and return
          to a steady rhythm.
        </p>

        {!isAnimating && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              marginBottom: "32px",
            }}
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                borderLeft: "4px solid #3b82f6",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.04)",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1e293b",
                  marginBottom: "8px",
                }}
              >
                Inhale for 4 counts.
              </div>
            </div>

            <div
              style={{
                padding: "20px",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                borderLeft: "4px solid #10b981",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.04)",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1e293b",
                  marginBottom: "8px",
                }}
              >
                Hold the breath for 4.
              </div>
            </div>

            <div
              style={{
                padding: "20px",
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                borderLeft: "4px solid #f59e0b",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.04)",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1e293b",
                  marginBottom: "8px",
                }}
              >
                Exhale slowly for 4.
              </div>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
            marginTop: "32px",
          }}
        >
          <button
            style={{
              color: "#ffffff",
              padding: "12px 24px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: 500,
              transition: "background-color 0.2s",
            }}
            onClick={() => onClickTryItNow()}
          >
            Try it now
          </button>

          <div
            style={{
              width: "200px",
              height: "173px",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="200"
              height="173"
              viewBox="0 0 200 173"
              style={{ overflow: "visible" }}
            >
              {/* Triangle path - equilateral triangle */}
              <path
                d="M 100 20 L 20 153 L 180 153 Z"
                fill="none"
                stroke="#e2e8f0"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              {/* Animated triangle sides */}
              {isAnimating && (
                <>
                  {/* Top-right side (Yellow - 0-4s) - left to right */}
                  <path
                    d="M 100 20 L 180 153"
                    fill="none"
                    stroke="#f59e0b"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="200"
                    strokeDashoffset={isAnimating ? "0" : "200"}
                    style={{
                      animation: isAnimating
                        ? "drawLine1 4s linear forwards"
                        : "none",
                    }}
                  />
                  {/* Bottom side (Green - 4-8s) - right to left */}
                  <path
                    d="M 180 153 L 20 153"
                    fill="none"
                    stroke="#10b981"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="200"
                    strokeDashoffset={isAnimating ? "0" : "200"}
                    style={{
                      animation: isAnimating
                        ? "drawLine2 4s linear 4s forwards"
                        : "none",
                    }}
                  />
                  {/* Top-left side (Blue - 8-12s) - left to right */}
                  <path
                    d="M 20 153 L 100 20"
                    fill="none"
                    stroke="#3b82f6"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="200"
                    strokeDashoffset={isAnimating ? "0" : "200"}
                    style={{
                      animation: isAnimating
                        ? "drawLine3 4s linear 8s forwards"
                        : "none",
                    }}
                  />
                </>
              )}
            </svg>
            <style>{`
                            @keyframes drawLine1 {
                                from {
                                    stroke-dashoffset: 200;
                                }
                                to {
                                    stroke-dashoffset: 0;
                                }
                            }
                            @keyframes drawLine2 {
                                from {
                                    stroke-dashoffset: 200;
                                }
                                to {
                                    stroke-dashoffset: 0;
                                }
                            }
                            @keyframes drawLine3 {
                                from {
                                    stroke-dashoffset: 200;
                                }
                                to {
                                    stroke-dashoffset: 0;
                                }
                            }
                        `}</style>
          </div>
        </div>

        <p
          style={{
            fontSize: "14px",
            lineHeight: "1.6",
            color: "#64748b",
            marginTop: "24px",
            textAlign: "center",
          }}
        >
          The even rhythm helps shift attention from thoughts to the body and
          creates a short pause before the next action.
        </p>
      </div>
      <div className="buttons-wrapper">
        <ButtonsSection />
      </div>
    </div>
  );
}
